(function () {
  'use strict';

  var PREFIX = 'Lieferzeit: ';

  function resolveLieferzeit(variant, product) {
    var v = variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.lieferzeit_text;
    if (v) return v;
    var p = product && product.metafields && product.metafields.custom && product.metafields.custom.lieferzeit_text;
    if (p) return p;
    return null;
  }

  function getProductJSON(root) {
    var s = root.querySelector('script[type="application/json"][data-product-json]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function bindBadge(root) {
    if (root.dataset.deliveryBound) return;
    var badge = root.querySelector('[data-delivery-badge]');
    if (!badge) return;
    var textEl = badge.querySelector('[data-delivery-text]');
    var product = getProductJSON(root);
    if (!product) return;
    root.dataset.deliveryBound = '1';
    root.addEventListener('trautis:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      var val = v ? resolveLieferzeit(v, product) : null;
      if (val && textEl) {
        textEl.textContent = PREFIX + val;
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(bindBadge);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  // Exposed for test harness only; no runtime callers.
  window.TrautisDeliveryBadge = { resolveLieferzeit: resolveLieferzeit };
})();

// Node.js / test harness export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' && window.TrautisDeliveryBadge) || {
    resolveLieferzeit: function () { return null; }
  };
}
